export enum RequestType{
    ZERO,
    VISIT,
    INTERVIEW,
    APPLICATION
}
